import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "./api";
import { logger } from "./logger";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Tenta restaurar sessao via cookie httpOnly.
  useEffect(() => {
    // CRITICAL: se retornando do callback OAuth Google, pula o /me — o
    // AuthCallbackPage vai processar o session_id e popular user antes.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    let active = true;
    api.get("/auth/me")
      .then((r) => { if (active) setUser(r.data); })
      .catch(() => { if (active) setUser(null); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  const login = useCallback(async (cpf, password) => {
    const r = await api.post("/auth/login", { cpf, password });
    setUser(r.data.user);
    return r.data.user;
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (e) { logger.warn("logout falhou", e); }
    setUser(null);
  }, []);

  const value = useMemo(() => ({ user, login, logout, loading, setUser }), [user, login, logout, loading]);

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
